import { CommonMessages } from 'src/messages/validationMessages'
import * as Yup from 'yup'

export const ContactUsSchema = Yup.object().shape({
    subject: Yup.string().required(CommonMessages.subject_required),
    message: Yup.string().required(CommonMessages.message_required),
})